// extracted by mini-css-extract-plugin
export var billingAddress = "_rt-g";
export var contactInfo = "_rt-d";
export var customerInfoContainer = "_rt-c";
export var customerInfoContainerMobile = "_rt-h";
export var customerInfoRow = "_rt-a";
export var customerInfoSection = "_rt-b";
export var fullWidthDividerMobile = "_rt-i";
export var imageContainer = "_rt-1";
export var paymentMethod = "_rt-e";
export var priceText = "_rt-6";
export var priceTextMobile = "_rt-7";
export var product = "_rt-0";
export var productImage = "_rt-2";
export var productInfo = "_rt-4";
export var productMobile = "_rt-9";
export var productTitle = "_rt-8";
export var quantityBadge = "_rt-3";
export var quantityText = "_rt-5";
export var shippingAddress = "_rt-f";